<template>
  <div v-if="navigation">
    <h3>Header Navigation</h3>
    <div class="h4 py-5">僅提供文案編輯修改</div>
    <div class="form-item d-flex py-5"
         v-for="item in navigation.footer_menu"
         :key="item.key">
      <h4 class="h4">{{ item.val }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigation: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
